import { render, staticRenderFns } from "./UserJobOrderForm.vue?vue&type=template&id=f1311916&"
import script from "./UserJobOrderForm.vue?vue&type=script&lang=js&"
export * from "./UserJobOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports